import { useState } from 'react';
import { Skeleton, Stack } from '@mui/material';
import { useLocation, useNavigate } from 'react-router';
import { CancelConfirmDialog } from './components/cancel-confirm-dialog';
import { RefundRequestProvider, useRefundRequest } from './context';
import { InvoiceAttachment } from './steps/invoice-attachment';
import { InvoiceValidation } from './steps/invoice-validation';
import { Payment } from './steps/payment';
import { ResourceApproval } from './steps/resource-approval';
import { ResourceDescription } from './steps/resource-description';
import { PageContainer } from '@/components/shared/page-container';
import { PageHeader } from '@/components/shared/page-header';
import { useSetTitle } from '@/hooks/use-set-title';
import { RefundStatus } from '@/models/subsidy/status';

const cancelableStatuses: RefundStatus[] = [
  RefundStatus.ResourceApprovalApproved,
  RefundStatus.ResourceApprovalPendingApproval,
  RefundStatus.ResourceApprovalRevisionRequired,
  RefundStatus.RefundRequestPendingApproval,
  RefundStatus.RefundRequestRevisionRequired,
];

const RefundRequestContent = () => {
  useSetTitle('Detalhes da solicitação');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isLoading, refundStatus } = useRefundRequest();
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);

  const isRefundRequestFlow = pathname.includes('solicitacao');
  const canCancel =
    isRefundRequestFlow &&
    refundStatus !== null &&
    cancelableStatuses.includes(refundStatus);

  const headerActions = canCancel
    ? [
        {
          label: 'Cancelar solicitação',
          onClick: () => setCancelDialogOpen(true),
        },
      ]
    : undefined;

  if (isLoading) {
    return (
      <PageContainer>
        <Stack spacing={2}>
          <Skeleton width={200} />
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} height={100} variant="rounded" />
          ))}
        </Stack>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <PageHeader
        backNavigationText="Meus reembolsos"
        handleBackNavigation={() => navigate('/meus-reembolsos')}
        actions={headerActions}
      />
      <Stack gap={2}>
        <ResourceDescription />
        <ResourceApproval />
        <InvoiceAttachment />
        <InvoiceValidation />
        <Payment />
      </Stack>
      {cancelDialogOpen && (
        <CancelConfirmDialog onClose={() => setCancelDialogOpen(false)} />
      )}
    </PageContainer>
  );
};

export const RefundRequest = () => {
  return (
    <RefundRequestProvider>
      <RefundRequestContent />
    </RefundRequestProvider>
  );
};
